module.exports = __webpack_public_path__ + "img/dashboard_as_mono_icon.17923fce.svg";